export default __webpack_public_path__ + "static/media/main-dark.c6bd35cf.png";